import { useDocumentVisibility, useTitle } from '@vueuse/core';
import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', () => {
    const totalUnreadCount = ref(0);
    const title = useTitle();
    const route = useRoute();
    const visibility = useDocumentVisibility();

    function updateTotalUnreadCount(count: number) {
        totalUnreadCount.value = count;
    }

    watchEffect(() => {
        if (visibility.value === 'hidden' && totalUnreadCount.value > 0) {
            title.value = `您有（${totalUnreadCount.value}）条未读消息 - 掌上大学客服系统`;
        } else {
            title.value = '掌上大学客服系统';
            if (route.meta?.title) {
                title.value = `${route.meta.title} - 掌上大学客服系统`;
            } else {
                title.value = '掌上大学客服系统';
            }
        }
    });

    return {
        totalUnreadCount,
        updateTotalUnreadCount
    };
});
